import React from 'react';

// Importing rich visual assets to fuse into the background matrix
import visionBg from '../assets/banner2.jpg';
import missionBg from '../assets/banner3.jpg';

const HomeBanner2 = () => {
  return (
    <section style={styles.bannerSection} className="py-5 position-relative">
      <div className="container my-lg-4">
        
        {/* Header Block */}
        <div className="row justify-content-center text-center mb-5">
          <div className="col-12 col-md-8 col-lg-6">
            <div style={styles.label} className="text-uppercase mb-2">Our Direction</div>
            <h2 style={styles.title} className="fw-medium text-white mb-3">Vision & Mission</h2>
            <div style={styles.divider} className="mx-auto"></div>
          </div>
        </div>

        {/* Responsive Content Asymmetry Layout */}
        <div className="row g-4 justify-content-center">
          
          {/* Vision Card Component Block */}
          <div className="col-12 col-md-6 col-lg-5">
            <div 
              style={{...styles.panelCard, backgroundImage: `url(${visionBg})`}}
              className="h-100 d-flex flex-column justify-content-between overflow-hidden position-relative"
            >
              {/* Modern Layered Gradients to fuse text smoothly over the asset image */}
              <div style={styles.cardOverlay}></div>
              
              <div style={styles.cardContent} className="position-relative">
                <div style={styles.iconWrapper} className="d-flex align-items-center justify-content-center mb-4">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ED8936" strokeWidth="1.5">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                </div>
                <h3 style={styles.cardTitle} className="text-white mb-3">Our Vision</h3>
                <p style={styles.cardText} className="mb-4">
                  To become a leading Tanzanian enterprise transforming agricultural potential and 
                  water resources into sustainable opportunities that nourish communities, empower 
                  livelihoods, and drive inclusive economic growth across Africa.
                </p>
              </div>
              <div style={styles.taglineFallback} className="position-relative w-100 text-uppercase pt-3">
                Transforming Resources into Opportunities
              </div>
            </div>
          </div>

          {/* Mission Card Component Block */}
          <div className="col-12 col-md-6 col-lg-5">
            <div 
              style={{...styles.panelCard, backgroundImage: `url(${missionBg})`}}
              className="h-100 d-flex flex-column justify-content-between overflow-hidden position-relative"
            >
              <div style={styles.cardOverlay}></div>
              
              <div style={styles.cardContent} className="position-relative">
                <div style={styles.iconWrapper} className="d-flex align-items-center justify-content-center mb-4">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#38A169" strokeWidth="1.5">
                    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
                  </svg>
                </div>
                <h3 style={styles.cardTitle} className="text-white mb-3">Our Mission</h3>
                <p style={styles.cardText} className="mb-4">
                  To deliver high-quality agricultural processing and water infrastructure solutions through 
                  innovation, sustainability, and operational excellence, creating value for farmers, customers, 
                  communities, employees, and stakeholders while contributing to Tanzania's socio-economic development.
                </p>
              </div>
              <div style={styles.taglineFallback} className="position-relative w-100 text-uppercase pt-3">
                From Farm to Future, From Water to Prosperity
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

const styles = {
  bannerSection: {
    backgroundColor: '#111A2E',
    fontFamily: "'Libre Franklin', sans-serif",
  },
  label: {
    fontSize: '11px',
    color: '#ED8936',
    letterSpacing: '0.15em',
  },
  title: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 'calc(1.8rem + 1vw)', // Fluid typography scaling
  },
  divider: {
    width: '50px',
    height: '2px',
    backgroundColor: '#1E2D4A',
  },
  panelCard: {
    backgroundColor: '#0A0F18',
    border: '1px solid #1E2D4A',
    padding: '40px 32px 32px',
    borderRadius: '8px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight: '420px',
  },
  cardOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(180deg, rgba(10, 15, 24, 1) 0%, rgba(10, 15, 24, 0.95) 90%)',
    zIndex: 1,
  },
  cardContent: {
    zIndex: 2,
  },
  iconWrapper: {
    width: '54px',
    height: '54px',
    backgroundColor: 'rgba(17, 26, 46, 0.9)',
    border: '1px solid #1E2D4A',
    borderRadius: '4px',
  },
  cardTitle: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: '28px',
  },
  cardText: {
    fontSize: '14.5px',
    color: '#CBD5E0',
    lineHeight: '1.75',
  },
  taglineFallback: {
    zIndex: 2,
    fontSize: '10.5px',
    fontWeight: '600',
    letterSpacing: '0.08em',
    color: '#718096',
    borderTop: '1px solid rgba(30, 45, 74, 0.6)',
  },
};

export default HomeBanner2;